import ConfigCardAccordionContent from "../../../components/configCardContent/configCardAccordionContent";
import {
  CredentialWithId,
  PortalCredentialGroup,
} from "../types/credentialTypes";
import SingleCredentialCard from "./SingleCredentialCard";

interface CredentialsPortalAccordionListProps {
  portalGroups: PortalCredentialGroup[];
  selectedCredentialId: string | null;
  onSelectCredential: (credential: CredentialWithId) => void;
}

/**
 * Renders the portal-grouped credentials list shown on the left side of the
 * credentials configuration page. Each portal becomes an accordion containing
 * its associated credentials as selectable cards.
 */
export const CredentialsPortalAccordionList = ({
  portalGroups,
  selectedCredentialId,
  onSelectCredential,
}: CredentialsPortalAccordionListProps) => {
  return (
    <div className="flex min-h-0 flex-col gap-2 overflow-auto">
      {portalGroups.map((portalGroup) => (
        <ConfigCardAccordionContent
          key={portalGroup.portal_id}
          title="Portal ID"
          description={portalGroup.portal_id}
          defaultOpen={false}
        >
          <div className="flex flex-col gap-2">
            {portalGroup.credentials.map((credential) => (
              <SingleCredentialCard
                key={credential.id}
                id={credential.id}
                title={credential.username}
                description={credential.portal_name}
                isActive={credential.is_active}
                showWarning={credential.isDuplicate}
                isCredentialSelected={selectedCredentialId === credential.id}
                onClick={() => onSelectCredential(credential)}
              />
            ))}
          </div>
        </ConfigCardAccordionContent>
      ))}
    </div>
  );
};
